import { defineComponent, computed, createElementBlock, openBlock, unref, createElementVNode, createCommentVNode, renderSlot, createVNode, createBlock, toDisplayString } from 'vue';
import _sfc_main$2 from './basler-components.es125.js';
/* empty css                        */
import _sfc_main$5 from './basler-components.es127.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es131.js';
/* empty css                        */
import _sfc_main$4 from './basler-components.es129.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es106.js';
/* empty css                        */

const _hoisted_1 = ["data-version"];
const _hoisted_2 = { class: "page-footer__inner" };
const _hoisted_3 = { class: "page-footer__topbar" };
const _hoisted_4 = {
  key: 0,
  class: "page-footer__tagline"
};
const _hoisted_5 = { class: "page-footer__content" };
const _hoisted_6 = { class: "page-footer__content-box01" };
const _hoisted_7 = { class: "page-footer__content-box02" };
const _hoisted_8 = { class: "page-footer__content-box03" };
const _hoisted_9 = { class: "page-footer__content-box04" };
const _hoisted_10 = { class: "page-footer__bottom-bar" };
const _hoisted_11 = { class: "page-footer__copyright" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PageFooter",
  props: {
    navFooterItems: {},
    navLegalItems: {},
    navLegalLine1: {},
    navLegalLine2: {},
    navSocial: {},
    newsletterRegistration: {},
    tagline: {}
  },
  emits: ["submit-newsletter"],
  setup(__props, { emit: __emit }) {
    const packageJsonVersion = '"0.57.3"';
    const props = __props;
    const navFooterItemsFirstHalf = computed(() => {
      if (props.navFooterItems.length > 3) {
        let firstHalf = Math.ceil(props.navFooterItems.length / 2);
        return props.navFooterItems.slice(0, firstHalf);
      }
      return props.navFooterItems;
    });
    const navFooterItemsSecondHalf = computed(() => {
      if (props.navFooterItems.length > 3) {
        let firstHalf = Math.ceil(props.navFooterItems.length / 2);
        return props.navFooterItems.slice(firstHalf, props.navFooterItems.length);
      }
      return [];
    });
    const emit = __emit;
    const emitSubmitNewsletter = (email) => {
      emit("submit-newsletter", email);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("footer", {
        class: "page-footer",
        "data-version": unref(packageJsonVersion) || "unknown"
      }, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            _ctx.tagline ? (openBlock(), createElementBlock("figure", _hoisted_4, [
              createVNode(_sfc_main$1, {
                image: _ctx.tagline,
                sizes: "",
                lazyload: true
              }, null, 8, ["image"])
            ])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "region-language-selector")
          ]),
          _cache[0] || (_cache[0] = createElementVNode("hr", { class: "page-footer__divider" }, null, -1)),
          createElementVNode("div", _hoisted_5, [
            createElementVNode("div", _hoisted_6, [
              createVNode(_sfc_main$2, { items: navFooterItemsFirstHalf.value }, null, 8, ["items"])
            ]),
            createElementVNode("div", _hoisted_7, [
              createVNode(_sfc_main$2, { items: navFooterItemsSecondHalf.value }, null, 8, ["items"])
            ]),
            createElementVNode("div", _hoisted_8, [
              createVNode(_sfc_main$3, {
                onSubmitForm: emitSubmitNewsletter,
                headline: props.newsletterRegistration.headline,
                copy: props.newsletterRegistration.copy,
                placeholder: props.newsletterRegistration.placeholder,
                "submit-button-label": props.newsletterRegistration.submitButtonLabel
              }, null, 8, ["headline", "copy", "placeholder", "submit-button-label"])
            ]),
            createElementVNode("div", _hoisted_9, [
              props.navSocial ? (openBlock(), createBlock(_sfc_main$4, {
                key: 0,
                title: props.navSocial.title,
                text: props.navSocial.text,
                items: props.navSocial.items
              }, null, 8, ["title", "text", "items"])) : createCommentVNode("", true)
            ])
          ]),
          _cache[1] || (_cache[1] = createElementVNode("hr", { class: "page-footer__divider" }, null, -1)),
          createElementVNode("div", _hoisted_10, [
            createVNode(_sfc_main$5, {
              items: props.navLegalItems
            }, null, 8, ["items"]),
            createElementVNode("div", _hoisted_11, [
              createElementVNode("p", null, toDisplayString(props.navLegalLine1), 1),
              createElementVNode("p", null, toDisplayString(props.navLegalLine2), 1)
            ])
          ])
        ])
      ], 8, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
